function ensureObject(value, fallback = {}) {
  return value && typeof value === 'object' ? value : fallback;
}

export function normalizeChallengeResponse(payload) {
  const source = ensureObject(payload);
  const kdf = ensureObject(source.kdf);

  return {
    challengeId: String(source.challengeId || ''),
    nonce: String(source.nonce || ''),
    saltPwd: String(source.saltPwd || ''),
    kdf: {
      iterations: Number(kdf.iterations || 310000),
      length: Number(kdf.length || 32),
    },
    needsLegacy: !!source.needsLegacy,
  };
}

export function assertChallengeResponse(payload) {
  const normalized = normalizeChallengeResponse(payload);

  if (!normalized.challengeId || !normalized.nonce || !normalized.saltPwd) {
    throw new Error('Resposta inválida de auth.challenge');
  }

  if (!Number.isFinite(normalized.kdf.iterations) || normalized.kdf.iterations <= 0) {
    throw new Error('Resposta inválida de auth.challenge: kdf.iterations');
  }

  if (!Number.isFinite(normalized.kdf.length) || normalized.kdf.length <= 0) {
    throw new Error('Resposta inválida de auth.challenge: kdf.length');
  }

  return normalized;
}

export function normalizeSessionDataResponse(payload) {
  const source = ensureObject(payload);
  return {
    authenticated: !!source.authenticated,
    token: source.token || null,
    profile: ensureObject(source.profile),
    menus: Array.isArray(source.menus) ? source.menus : [],
  };
}
